<div [hidden]="addEditMode">
    <div class="content-space-between">
        <h1>{{ 'services_real_server' | myLbTranslate }}</h1>
        <button
            id="add-real-server"
            class="primary"
            (click)="addEditRealServer()">
            {{ 'services_add_real_server' | myLbTranslate }}
        </button>
    </div>

    <app-table
        id="realServers-table"
        [data]="tableRows"
        [selectedRows]="selectedRows"
        [multiSelectActions]="multiSelectActions"
        [showCSVDownload]="false"
        (selectedRowsOut)="onSelect($event)">
        <app-column [flexGrow]="1" prop="name" label="services_real_server_name"></app-column>
        <app-column [flexGrow]="1.5" prop="ip" label="ip"></app-column>
        <app-column [flexGrow]="0.5" prop="port" label="port"></app-column>
        <app-column [flexGrow]="1" prop="usage" label="usage" [cellTemplate]="usageTemplate">
            <ng-template let-row #usageTemplate>
                <app-usage
                    [usage]="row.usage"
                    [columnHeaders]="['service', 'section', 'services_name']"
                    [rowProperties]="['serviceFullName', 'sectionFullName', 'serviceName']"
                    modalTitle="services_real_server_usage">
                </app-usage>
            </ng-template>
        </app-column>
        <app-column [flexGrow]="1" prop="status" label="status" [cellTemplate]="rsStatus">
            <ng-template let-row #rsStatus>
                <span>{{ row.status }}</span>
            </ng-template>
        </app-column>
        <app-column
            [flexGrow]="0.5"
            prop="actions"
            label=""
            cellAlignment="right"
            [cellTemplate]="rsActionsi">
            <ng-template let-row #rsActionsi>
                <app-action-dots>
                    <button
                        *ngIf="row.existingRip"
                        id="service-details-duplicate-real-server"
                        (click)="duplicateRealServer(row)">
                        {{ 'duplicate' | myLbTranslate }}
                    </button>
                    <button
                        *ngIf="!row.existingRip"
                        id="service-details-edit-real-server"
                        (click)="addEditRealServer(row)">
                        {{ 'edit' | myLbTranslate }}
                    </button>
                    <button
                        *ngIf="!row.existingRip"
                        id="service-details-delete-real-server"
                        (click)="deleteRealServer(row)">
                        {{ 'delete' | myLbTranslate }}
                    </button>
                </app-action-dots>
            </ng-template>
        </app-column>
    </app-table>
</div>


<ng-container #addEditContainer></ng-container>
